import axios from 'axios'

export default {
  evaluate (text) {
    return axios.post('https://es.northernfox.net/api/entrysheet/evaluate', {
      q: text
    }).then((response) => {
      return response.data
    })
  },
  regist ({commit}, text) {
    return axios.post('https://es.northernfox.net/api/entrysheet/regist', {
      q: text
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/evaluate.js